import { render, staticRenderFns } from "./ubicacion.vue?vue&type=template&id=424d1810&scoped=true&"
import script from "./ubicacion.vue?vue&type=script&lang=ts&"
export * from "./ubicacion.vue?vue&type=script&lang=ts&"
import style0 from "./ubicacion.vue?vue&type=style&index=0&id=424d1810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424d1810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('424d1810', component.options)
    } else {
      api.reload('424d1810', component.options)
    }
    module.hot.accept("./ubicacion.vue?vue&type=template&id=424d1810&scoped=true&", function () {
      api.rerender('424d1810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/VerUbicacion/ubicacion.vue"
export default component.exports